<div class="carousel slide" id="carouselExampleControls" data-bs-ride="carousel">
    <div class="carousel-inner">
      <div class="d-flex justify-content-center mt-4">
        <div class="title-bold">
          Categories
        </div>
      </div>
      <owl-carousel-o [options]="withControlOptions">
        @for (cat of categories; track cat) {
        <ng-template carouselSlide class="carousel-item">
                <!-- <img class="w-100" [src]="slideData.img" alt="">  -->
                <div class="bg-primary rounded p-5 m-2 mt-5 pointer" (click)="redirectToSearch(cat._id)">
                    <div class="d-flex faq-widgets">
                      <div class="flex-grow-1 align-self-center">
                        <h4>{{cat.name}}</h4>
                      </div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-book-open"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
                    </div>
                </div>
          </ng-template>
        }
      </owl-carousel-o>
    </div>
  </div>